<template>
  <c-select
    class="CoinSelect"
    :promptText="$t('assets.addressMent.coin')"
    :errorHave="false"
    :value="myValue"
    :options="options"
    :filterable="true"
    newStyleFormat
    type="slot"
    fill
    @onChanges="selectLineChange">
      <div slot="options" slot-scope="scope" class="optionItem">
        <img class="imgIcon" :src="scope.row.img"/>
        <span class="coinName">{{ scope.row.value }}</span>
        <span class="coinName">{{ currentCoinInfo[scope.row.value] && currentCoinInfo[scope.row.value].longName }}</span>
      </div>
    </c-select>
</template>

<script>
export default {
  name: 'OTCCoinSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    // 是否初始化第一个symbol
    init: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myValue: '',
      options: [],
      otcAccountList: [],
    };
  },
  computed: {
    market() {
      return this.$store.state.baseData.market;
    },
    // 保证金币种列表
    marginCoinList() {
      return this.$store.state.future.marginCoinList;
    },
    currentItem() {
      if (this.myValue) {
        const item = this.otcAccountList.find(symbol => symbol.coinSymbol === this.myValue);
        return item;
      }
      return null;
    },
    currentCoinInfo() {
      const currentCoinInfo = {};
      const { coinSymbolIntroduce } = this.$store.state.baseData;
      coinSymbolIntroduce.forEach((el) => {
        currentCoinInfo[el.coinSymbol] = el;
      });
      return currentCoinInfo;
    },
  },
  watch: {
    market: {
      immediate: true,
      handler() {
        this.setOptions();
      },
    },
    marginCoinList: {
      immediate: true,
      handler() {
        this.setOptions();
      },
    },
    value: {
      immediate: true,
      handler() {
        this.setMyValue();
      },
    },
  },
  created() {
    this.$store.dispatch('getFutorePublicInfo');
  },
  methods: {
    setOptions() {
      if (!this.market || !this.marginCoinList) {
        return;
      }
      const list = [];
      const coinList = this.market.coinList;
      this.marginCoinList.forEach((coinSymbol) => {
        const coinKey = coinSymbol.toUpperCase();
        const coinListItem = coinList[coinKey];
        if (coinListItem) {
          list.push({
            img: coinListItem.icon,
            value: coinListItem.showName,
            code: coinKey,
          });
        }
      });
      this.options = list;
      if (this.init && !this.value && list.length > 0) {
        this.myValue = list[0].code;
      }
      this.onUpdate();
    },

    setMyValue() {
      try {
        this.myValue = this.value;
        this.onUpdate();
      } catch (error) {
        this.myValue = '';
      }
    },

    selectLineChange(item) {
      this.myValue = item.code;
      this.onUpdate();
    },

    onUpdate() {
      this.$emit('input', this.myValue, this.currentItem);
      this.$emit('change', this.myValue, this.currentItem);
    },
  },
};
</script>
<style lang="scss" scoped>
.optionItem {
  display: flex;
  align-items: center;
  gap: 16px;
  line-height: 40px;
  height: 40px;
  overflow: hidden;

  .imgIcon {
    width: 18px;
    height: 18px;
  }

  .coinName {
    font-family: 'Alpex';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
  }
}
</style>
